import { createContext } from "react";
export const LogoContext = createContext({
  companyLogo: "",
  setLogo: () => {},
});
